import React from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom';

function Footer() {
  const current = new Date();
  const date = current.getFullYear();

  return (
    <footer className="bg-[#010066] text-center text-neutral-600 dark:bg-[#010066] dark:text-neutral-200 lg:text-left">

      <div className="mx-6 py-10 text-center md:text-left">
        <div className="grid-1 grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <h6 className="mb-4 flex items-center justify-center font-semibold uppercase md:justify-start underline underline-offset-4">
              EasyBooks Solutions
            </h6>
            <p>
              Simplifying Business Operations through ICT Innovations.
            </p>
          </div>
          <div>
            <h6 className="mb-4 flex justify-center font-semibold uppercase md:justify-start underline underline-offset-4">
              Products
            </h6>
            <p className="mb-4">
              <Link to="/EasyBooks_Accounting" className="text-neutral-600 dark:text-neutral-200">
                EasyBooks Accounting Software
              </Link>
            </p>
            <p className="mb-4">
              <Link to="/EasyBooks_ERP" className="text-neutral-600 dark:text-neutral-200">
                EasyBooks Enterprise Resource Planning Software
              </Link>
            </p>
            <p className="mb-4">
              <Link to="/EasyBooks_IMERIS" className="text-neutral-600 dark:text-neutral-200">
                EasyBooks IMERIS Software
              </Link>
            </p>
          </div>
          <div>
            <h6 className="mb-4 flex justify-center font-semibold uppercase md:justify-start underline underline-offset-4">
              Useful links
            </h6>
            <p className="mb-4">
              <Link to="/" className="text-neutral-600 dark:text-neutral-200">
                Home
              </Link>
            </p>
            <p className="mb-4">
              <Link to="/Clients" className="text-neutral-600 dark:text-neutral-200">
                Clients
              </Link>
            </p>
            <p className="mb-4">
              <Link to="/Contact" className="text-neutral-600 dark:text-neutral-200">
                Contact
              </Link>
            </p>
          </div>
          <div>
            <h6 className="mb-4 flex justify-center font-semibold uppercase md:justify-start underline underline-offset-4">
              Contact
            </h6>
            <p className="mb-4 flex items-center justify-center md:justify-start">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="mr-3 h-5 w-5">
                <path
                  d="M11.47 3.84a.75.75 0 011.06 0l8.69 8.69a.75.75 0 101.06-1.06l-8.689-8.69a2.25 2.25 0 00-3.182 0l-8.69 8.69a.75.75 0 001.061 1.06l8.69-8.69z" />
                <path
                  d="M12 5.432l8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 01-.75-.75v-4.5a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75V21a.75.75 0 01-.75.75H5.625a1.875 1.875 0 01-1.875-1.875v-6.198a2.29 2.29 0 00.091-.086L12 5.43z" />
              </svg>
              Area 47, sector 5, Near Zodiak Broadcasting Station
            </p>
            <a href='mailto:info@ebsolutionsmw.com' className="mb-4 flex items-center justify-center md:justify-start">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="mr-3 h-5 w-5">
                <path
                  d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" />
                <path
                  d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" />
              </svg>
              info@ebsolutionsmw.com
            </a>
            <a href='tel:+265884675719' className="mb-4 flex items-center justify-center md:justify-start">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="mr-3 h-5 w-5">
                <path
                  fillRule="evenodd"
                  d="M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z"
                  clipRule="evenodd" />
              </svg>
              +265 884 675 719
            </a>
          </div>
        </div>
      </div>
      <div className="bg-gray-200 p-6 text-center dark:bg-gray-200">
        <span className='text-black'>© {date} Copyright:</span>
        <span className="font-semibold text-black dark:text-black"> EasyBooks Solutions</span>
      </div>
    </footer>
  );
}

export default Footer;
